import { Cidade } from "../../endereco.model";
import { TarifarioRodoviario } from "./tarifario.model";
import { TrechoRodoviario } from "./trechorodoviario.model";

export class Rota {
    constructor() {
        this.TrechosRodoviarios = [];
        this.CidadeDestino = new Cidade();
        this.CidadeOrigem = new Cidade();
    }

    Id: number = 0;
    Nome: string = "";
    TarifarioRodoviario: TarifarioRodoviario;
    TarifarioRodoviarioId: number;
    CidadeOrigem: Cidade;
    CidadeDestino: Cidade;
    CidadeOrigemId: number;
    CidadeDestinoId: number;
    IdadeMinimaCHD: number;
    IdadeMaximaCHD: number;
    TrechosRodoviarios: TrechoRodoviario[] = [];
}
